import { SVG, SVGProps } from './svg'

export function IconDrawingSettingPreserveDrawings(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M8 7.5c-.3 0-.5.2-.5.5v16c0 .3.2.5.5.5h16c.3 0 .5-.2.5-.5v-6a.5.5 0 0 0-1 0v5.5h-15v-15H14a.5.5 0 0 0 0-1H8Zm10.5.5c0 .3.2.5.5.5h3.8l-8.3 8.3V13a.5.5 0 0 0-1 0v5c0 .3.2.5.5.5h5a.5.5 0 0 0 0-1h-3.8l8.3-8.3V13a.5.5 0 0 0 1 0V8c0-.3-.2-.5-.5-.5h-5c-.3 0-.5.2-.5.5Z" />
    </SVG>
  )
}
